/* eslint-disable no-console */
import { LoggerInterface } from 'Modules'

export const Logger: LoggerInterface = {
	info: (...args: any[]) => {
		const style =
			'background: #d1e7dd; color: #0f5132; padding: 4px 8px; border-radius: 3px; font-weight: 500;'
		console.log(`%c[INFO]`, style, ...args)
	},

	warn: (...args: any[]) => {
		const style =
			'background: #fff3cd; color: #664d03; padding: 4px 8px; border-radius: 3px; font-weight: 500;'
		console.warn(`%c[WARNING]`, style, ...args)
	},

	error: (...args: any[]) => {
		const style =
			'background: #f8d7da; color: #842029; padding: 4px 8px; border-radius: 3px; font-weight: 500;'
		console.error(`%c[ERROR]`, style, ...args)
	},

	debug: (...args: any[]) => {
		if (process.env.NODE_ENV === 'development') {
			const style =
				'background: #e9ecef; color: #495057; padding: 4px 8px; border-radius: 3px; font-weight: 500;'
			console.debug(`%c[DEBUG]`, style, ...args)
		}
	},

	group: (groupName: string) => {
		const style =
			'background: #6c757d; color: white; padding: 6px 12px; border-radius: 3px; font-weight: 600;'
		console.groupCollapsed(`%c${groupName}`, style)
	},

	groupEnd: () => {
		console.groupEnd()
	},
}
